const Toggle = () => {
    // Fetch all elements with a `data-toggle` attribute
    let toggles = document.querySelectorAll('[data-toggle]');
  
    Array.from(toggles).forEach((toggle) => {
      let className = toggle.getAttribute('data-toggle');
      let targetElement = document.querySelector(`.${className}`);
  
      if (targetElement) {
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
  
          // Toggle the BEM modifier on the target
          targetElement.classList.toggle(`${className}--active`);
  
          // Also toggle a class on the button itself (to show/hide icons)
          toggle.classList.toggle('is-active');
        });
      }
    });
  };
  
  export default Toggle;
  